import React from "react";
import Kpk from "./KpkCom";
import KpkEntryToPrisoner from "./KpkEntryToPrisoner";
import KpkIncarceration from "./KpkIncarceration";
import KpkPrisonStatistics from "./KpkPrisonStatistics";
import KpkTimeline from "./KpkTimeline";
import KpkVoicenotes from "./KpkVoicenotes";

function KpkIndex() {
  return (
    <div>
      <div className="bg-kpk-img">
        <div className="container">
          <Kpk />
          <KpkTimeline />
        </div>
        <div>
          <img
            style={{ width: "100%", height: "100%" }}
            src={require("../../assets/images/bgcrop.png")}
            alt="bgcrop"
          />
        </div>
      </div>
      <div className="container">
        <KpkVoicenotes />
        <div>
          <img
            style={{ width: "100%", height: "100%" }}
            src={require("../../assets/images/voice2.png")}
            alt="voice2"
          />
        </div>
        <KpkIncarceration />
        <KpkPrisonStatistics />
      </div>
      <KpkEntryToPrisoner />
    </div>
  );
}

export default KpkIndex;
